module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v("\n    New Category\n    "), _c('i', {
    staticClass: "material-icons action-icon"
  }, [_vm._v("add")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e49e224!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/NewCategory.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4e49e224!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/NewCategory.vue
// module chunks = 0